var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Sections extends Component {
    constructor() {
        super('Sections', false);
        this.currentSectionIndex = 0;
        this.sectionsCount = 0;
        this.leftMargin = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.sections-container').length > 0) {
                this.sectionsCount = $('.sections-container .section').length;
                // Events
                $('.sections-container .btn-prev').on('click', () => {
                    this.prev();
                });
                $('.sections-container .btn-next').on('click', () => {
                    this.next();
                });
                $(window).on('keyup', (event) => {
                    if (event.key === 'ArrowLeft')
                        this.prev();
                    if (event.key === 'ArrowRight')
                        this.next();
                });
                $(window).on('resize', () => {
                    this.update(false);
                });
                // Scroll to section according to hash
                if ($('.sections-container').length > 0 && location.hash) {
                    if ($(window).width() > 991 && $(window).height() > 800) {
                        this.currentSectionIndex = $(location.hash).index();
                        this.update(false);
                    }
                    else {
                        setTimeout(() => {
                            scrollTo(0, $(location.hash).position().y - $('header').height() - 24);
                        }, 250);
                    }
                }
            }
            this.success();
        });
    }
    prev() {
        if (this.currentSectionIndex > 0) {
            this.currentSectionIndex--;
            this.update();
        }
    }
    next() {
        if (this.currentSectionIndex < this.sectionsCount - 2) {
            this.currentSectionIndex++;
            this.update();
        }
    }
    update(animated = true) {
        let x = this.currentSectionIndex > 0 ? this.currentSectionIndex * $('.section').width() + 12 : 0;
        if (!animated)
            $('.sections-content').addClass('no-transition');
        $('.sections-content').css('transform', `translateX(-${x}px)`);
        setTimeout(() => {
            $('.sections-content').removeClass('no-transition');
        }, 100);
        $('.section').removeClass('active');
        $(`.section:nth-child(${this.currentSectionIndex + 1})`).addClass('active');
        // Update buttons state
        $('.btn-prev, .btn-next').removeClass('disabled');
        if (this.currentSectionIndex === 0)
            $('.btn-prev').addClass('disabled');
        if (this.currentSectionIndex >= this.sectionsCount - 2)
            $('.btn-next').addClass('disabled');
    }
}
